import { Injectable } from "@angular/core";
import { filter } from "rxjs/operators";
import { ConfigureService } from "../configure/configure.service";

@Injectable()
export class GoogleMapsConfig {
    apiKey = "";

    constructor(private config: ConfigureService) {
        this.config.paramsLoadedSubject
            .pipe(filter((data) => !!data))
            .subscribe((params) => {
                this.apiKey = params.googleMapsAPIkey;
            });
    }
}
